import { Radio, withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  correctOption: {
    color: theme.HeaderSelectedText ?? '#05A792'
  },
  incorrectOption: {
    color: theme.error ?? '#CF0000'
  },
  validationLabelStyles: {
    marginLeft: 28,
    fontSize: theme.headerTextFontSize ?? 14
  },
  radioRoot: {
    padding: 4,
    color: theme.iconColor ?? '#666666',
    '&$radioDisabled': {
      color: theme.TextColor ?? '#000000'
    }
  },
  radioDisabled: {},
  optionLabel: {
    marginLeft: 4,
    fontSize: theme.headerTextFontSize ?? 14,
    color: theme.dispatchPanelHeaderColor ?? '#666666'
  },
  radioContainer: {
    marginBottom: 16
  },
  questionHeader: {
    fontSize: theme.headerTextFontSize ?? 14,
    color: theme.dispatchPanelHeaderColor ?? '#fff',
    marginBottom: 4
  },
  question: {
    fontSize: theme.headerTextFontSize ?? 14,
    color: theme.TextColor ?? '#fff',
    marginBottom: 24
  },
  radioLabel: {
    cursor: 'pointer'
  }
});
const QuestionOptions = ({
  questionOptions,
  handleChange,
  selectedOption,
  correctOption,
  questionNumber,
  totalQuestions,
  question,
  classes
}) => {
  const determineCorrectnessMessage = (option) => {
    if (!selectedOption) {
      return null;
    }
    if (selectedOption === option.id) {
      return selectedOption === correctOption
        ? { optionClasses: classes.correctOption, optionLabelText: 'Correct!' }
        : { optionClasses: classes.incorrectOption, optionLabelText: 'Incorrect!' };
    } else if (option.id === correctOption) {
      return { optionClasses: classes.correctOption, optionLabelText: 'Correct!' };
    } else {
      return null;
    }
  };
  return (
    <div>
      <div>
        <div className={classes.questionHeader}>
          Question {questionNumber} of {totalQuestions}
        </div>
        <div className={classes.question}>{question}</div>
      </div>
      {questionOptions.map((option) => {
        const { optionClasses, optionLabelText } = determineCorrectnessMessage(option) ?? {};
        return (
          <div className={classes.radioContainer}>
            <div>
              <label className={classes.radioLabel}>
                <Radio
                  checked={selectedOption === option.id}
                  onChange={handleChange}
                  value={option.id}
                  classes={{ root: classes.radioRoot, disabled: classes.radioDisabled }}
                  disabled={selectedOption !== null}
                />
                <span className={classes.optionLabel}>{option.text}</span>
              </label>
            </div>
            {selectedOption && (
              <div className={`${classes.validationLabelStyles} ${optionClasses}`}>
                {optionLabelText}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default withStyles(styles)(QuestionOptions);
